import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seventh-page',
  templateUrl: './seventh-page.component.html',
  styleUrls: ['./seventh-page.component.css']
})
export class SeventhPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
